import { Resources } from "Infrastructure/Translations/Resources";

export function formatStreetAddress(
  street?: string | null,
  streetNumber?: string | null,
  orientationNumber?: string | null,
): string | undefined {
  const parts = [street, streetNumber, orientationNumber].filter(Boolean);
  return parts.length > 0 ? parts.join(" ") : undefined;
}

export function translateCountryCode(
  countryCode: string | undefined | null,
  t: (key: string) => string,
): string | undefined {
  if (!countryCode) return undefined;
  const key =
    Resources.Common.Countries[
      countryCode as keyof typeof Resources.Common.Countries
    ];
  return key ? t(key) : countryCode;
}
